
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"FAQ_App_Icon","data-name":"FAQ App Icon","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Speech_Bubble_Group","data-name":"Speech Bubble Group","fill":"#f7f4e5"}},[_c('path',{attrs:{"id":"Triangle","d":"M617.77 649.56a35.07 35.07 0 00-31.12-18.9H412.49a35.06 35.06 0 00-28.69 55.23l87.08 123.92a35.07 35.07 0 0057.39 0l87.08-123.92a35.07 35.07 0 002.42-36.33z","transform":"translate(.43 .35)"}}),_c('ellipse',{attrs:{"id":"Speech_Bubble","data-name":"Speech Bubble","cx":"500","cy":"475.26","rx":"308.78","ry":"265.26"}})]),_c('g',{attrs:{"id":"Questionmark_Group","data-name":"Questionmark Group","fill":"#4d3d36"}},[_c('circle',{attrs:{"id":"Dot","cx":"498.82","cy":"655.21","r":"35.85"}}),_c('path',{attrs:{"id":"Curve","d":"M498.4 598.24a35.85 35.85 0 01-35.85-35.85 99.28 99.28 0 0156.83-89.56 49.58 49.58 0 0028.47-46c-.61-26-22.25-47.63-48.24-48.24A49.47 49.47 0 00448.93 428a35.85 35.85 0 01-71.7 0 121.17 121.17 0 11172.62 109.74 27.29 27.29 0 00-15.6 24.65 35.85 35.85 0 01-35.85 35.85z","transform":"translate(.43 .35)"}})])])
          )
        }
      }
    